/**
 * The "Month | Year" pill under a headline number. Picking one switches the
 * page's numbers between month to date and year to date.
 */

import { useTranslation } from "react-i18next";
import { SegmentedControl } from "./SegmentedControl";

/** The period the page's numbers cover. */
export type Period = "month" | "year";

export function PeriodTabs({
  value,
  onChange,
}: {
  value: Period;
  onChange: (next: Period) => void;
}) {
  const { t } = useTranslation();
  // Short label on screen, full name for screen readers
  const options = [
    { value: "month" as const, label: t("pages.pcInsights.period.month"), name: t("pages.pcInsights.period.monthName") },
    { value: "year" as const, label: t("pages.pcInsights.period.year"), name: t("pages.pcInsights.period.yearName") },
  ];

  return (
    // Space above the picker
    <div className="mt-3">
      <SegmentedControl
        label={t("pages.pcInsights.period.label")}
        options={options}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
